import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/lifetimeValueByMembershipsSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const MembersViewFilter = () => {
  const dispatch = useDispatch();

  const options = useSelector((state) => state.lifetimeValueByMembership.filters.members_view);
  const selectedOption = useSelector(
    (state) => state.lifetimeValueByMembership.selectedFilters.members_view
  );

  return (
    <MultiSelectDropdown
      options={options}
      selectedFilters={selectedOption}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updateFilters({ members_view: data }))}
    />
  );
};

export default MembersViewFilter;
